import PropTypes from "prop-types"

import Image from "components/ui/image"
import { mapMetalClass } from "helpers/product/sku-colors"
import { cn } from "styles/utils"

const DotIcon = ({ className, vermeil, ...props }) => (
  <div
    className={cn(
      "text-16 mr-8 size-16 rounded-full",
      vermeil && "bg-grey-20 border-sku-ky border-4",
      className
    )}
    {...props}
  />
)

const CategoryIcon = ({ category }) => {
  const icon = category.icon_href
  if (category.name === "Vermeil" || category.name === "Gold Plated") {
    return <DotIcon vermeil />
  } else if (icon && icon.dot_color) {
    return <DotIcon className={mapMetalClass(icon.dot_color)} />
  } else if (category.belongs_to === "Stone Shape") {
    return (
      <Image
        alt={category.name}
        className="mr-4"
        height="25px"
        src={require(
          `images/collections/icons/stonecuts/${category.icon_tag}.svg`
        )}
        title={category.name}
        width="25px"
      />
    )
  } else if (
    ["Birthstone", "Stones", "Stone Type"].includes(category.belongs_to)
  ) {
    return (
      <Image
        alt={category.name}
        className="mr-4"
        height="19px"
        src={`https://assets.jewlr.com/images/product/stones/40px/1x/side/${category.icon_tag}_RD.png`}
        srcSet={
          `${`https://assets.jewlr.com/images/product/stones/40px/1x/side/${category.icon_tag}_RD.png`} 40w,` +
          ` ${`https://assets.jewlr.com/images/product/stones/40px/2x/side/${category.icon_tag}_RD.png`} 80w`
        }
        title={category.name}
        width="19px"
      />
    )
  }

  return null
}

CategoryIcon.propTypes = {
  category: PropTypes.object,
}
DotIcon.propTypes = {
  className: PropTypes.string,
  vermeil: PropTypes.bool,
}
export default CategoryIcon
